import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../services/http-service.service';
import { Router } from '@angular/router';
import { PreparedStatement } from '../../model';
import { blurbQueryParam } from '../../model/blurb-response';
import { BlurbService } from '../../services/blurb.service';

@Component({
  selector: 'blurb-list',
  templateUrl: './blurb-list.component.html',
  styleUrls: ['./blurb-list.component.scss']
})

export class BlurbListComponent implements OnInit {

  blurbsList:PreparedStatement[] = [];
  totalItems:number = 0;
  loading:boolean = false;
  blurbQueryParam:blurbQueryParam = new blurbQueryParam();

  constructor(
    public httpClient:HttpClient,
    public httpService:HttpService,
    public router:Router,
    private blurbService: BlurbService
  ) { }

  ngOnInit(): void {
    this.getBlurbsList();
  }

  // getBlurbsList() - Get list of all blurbs.
  getBlurbsList(): void {
    this.loading = true;
    this.httpService.getBlurbsList(this.blurbQueryParam).subscribe((resp) => {
      if(resp.success){
        this.blurbsList = resp.result.items;
        this.totalItems = resp.result.totalItems;
        this.loading = false;
      }
    }, (error) => {
      if (error) {
        this.loading = false;
        //this.toastrService.error(error.message);
      }
    });
  }

  // pageChanged() - Event is fired when page is changed
  pageChanged(event): void {
    this.blurbQueryParam.page = event.page;
    this.getBlurbsList();
  }

  // editBlurb() - Edit blurb
  editBlurb(blurb:PreparedStatement): void{
    this.blurbService.setBlurb(blurb);
    this.router.navigate(['/manage/research/blurbs/new']);
  }

  // removeBlurb() - Remove blurb
  removeBlurb(blurb:PreparedStatement): void{
    this.httpService.removeBlurbItem(blurb).subscribe((resp) => {
      if(resp.success){
        this.getBlurbsList();
      }
    }, (error) => {
      if (error) {
        //this.toastrService.error(error.message);
      }
    });
  }

  // sortblurbs() - sort blurbs list.
  sortblurbs(fieldName:string): void{
    if(this.blurbQueryParam.field === fieldName){
      if(this.blurbQueryParam.order === 'ASC')
        this.blurbQueryParam.order = 'DESC';
      else
        this.blurbQueryParam.order = 'ASC';
    }else{
      this.blurbQueryParam.field = fieldName;
      this.blurbQueryParam.order = 'ASC';
    }
    this.getBlurbsList();
  }

}
